<!-- Load the Mapbox GL CSS stylesheet from the Mapbox API -->
<!-- These CSS file is required to display the map and make elements like Popups and Markers work. -->
<link
  href="https://api.mapbox.com/mapbox-gl-js/v2.13.0/mapbox-gl.css"
  rel="stylesheet"
/>
<!-- Load the Mapbox GL JavaScript library from the Mapbox API -->
<script src="https://api.mapbox.com/mapbox-gl-js/v2.13.0/mapbox-gl.js"></script>

<!-- Load a dynamic CSS file specified by the component's input property, if any -->
<link rel="stylesheet" [href]="theme.themeData.css ? (theme.themeData.css | safe) : null" />

<div class="map-report-container" id="currentView">
  <!-- A reference to a custom HTML element that can be updated dynamically -->
  <div #customHtmlElement id="customHtmlElement" class="custom-html-elements"></div>
  <!-- Show map -->
  <div id="map" class="map-report"></div>
</div>
